export const Stat = ({ label, children, value, onClick }) => {

  return (<div className="flex-1 flex">
    <div
      className={`gap-1 flex flex-1 flex-col px-6 py-4 `}
      onClick={onClick}
    >
      <p className="text-sm m-0 whitespace-nowrap text-zinc-500">{label}</p>
      <h3 className=" font-semibold m-0 text-2xl text-nowrap">{value}</h3>
    </div>
    {children && <div className="flex border-l items-end my-4">
      {children}
    </div>}
  </div>

  );
};


export const SubStat = ({ label, value }) => {

  return (
    <div
      className={`gap-1 flex  flex-col px-6`}
    >
      <p className="text-sm m-0 whitespace-nowrap text-zinc-500">{label}</p>
      <h3 className=" font-semibold m-0 text-sm text-nowrap">{value}</h3>
    </div>
  );
};
